export enum FundingSource {
  PERSONAL_CASH = "Personal cash",
  PERSONAL_SAVINGS = "Personal savings",
  INCOME = "Income",
  GIFT = "Gift",
  CASH_FROM_CROWDFUNDING = "Cash from crowdfunding",
  LOANS = "Loans",
  SBA_LOAN = "SBA loan",
  BANK_LOAN = "Business loan from bank",
  PERSONAL_CONSUMER_LOAN = "Personal/consumer loan",
  ONLINE_LENDER = "Business loan from an online lender",
  OUTSIDE_INVESTOR = "Outside investor",
  GRANT = "Grant",
}
